/* CENIT · Filtro instantáneo del catálogo (sections/cenit-catalog.liquid)
   · Lee los datos de cada tarjeta ([data-kf-item]): tipo, colores, colecciones, tallas, precio, disponibilidad.
   · Dentro de un grupo suma (azul O verde); entre grupos restringe (anillo Y azul).
   · Cada opción muestra cuántas piezas quedarían si la eliges.
   · El estado vive en la dirección: ?tipo=anillo&color=azul&col=orion&talla=6&min=300&max=900&disp=1&orden=precio-asc&q=vega
   · Ordena con la propiedad CSS "order": no mueve las tarjetas, así su galería y compra rápida siguen funcionando. */
(function () {
  var KINDS = { collar: 'Collares', pulsera: 'Pulseras', anillo: 'Anillos' };
  var KIND_ORDER = ['collar', 'pulsera', 'anillo'];
  var COLORS = {
    azul: 'Azul', celeste: 'Celeste', verde: 'Verde', morado: 'Morado', rosa: 'Rosa',
    rojo: 'Rojo', amarillo: 'Amarillo', multicolor: 'Multicolor', dorado: 'Dorado'
  };
  var COLOR_ORDER = Object.keys(COLORS);

  function norm(str) {
    return String(str || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function words(str) { return String(str || '').split(/\s+/).filter(Boolean); }
  function money(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
  function esc(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function init(root) {
    if (!root || root.dataset.kfReady) return;
    var grid = root.querySelector('[data-kf-grid]');
    if (!grid) return;
    root.dataset.kfReady = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileMq = window.matchMedia('(max-width: 989px)');
    var meta = {};
    try { meta = JSON.parse(root.querySelector('[data-kf-meta]').textContent); } catch (e) { meta = {}; }
    var colNames = meta.cols || {};

    var panel = root.querySelector('[data-kf-panel]');
    var groupsEl = root.querySelector('[data-kf-groups]');
    var quickEl = root.querySelector('[data-kf-quick]');
    var activeEl = root.querySelector('[data-kf-active]');
    var resultEl = root.querySelector('[data-kf-result]');
    var countEl = root.querySelector('[data-kf-count]');
    var badgeEl = root.querySelector('[data-kf-badge]');
    var emptyEl = root.querySelector('[data-kf-empty]');
    var sortEl = root.querySelector('[data-kf-sort]');
    var qEl = root.querySelector('[data-kf-q]');
    var openBtn = root.querySelector('[data-kf-open]');
    var scrim = root.querySelector('.kf__scrim');
    var promo = root.querySelector('[data-kf-promo]');
    var defaultSort = root.getAttribute('data-kf-default-sort') || 'destacados';

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-kf-item]')).map(function (el) {
      return {
        el: el,
        i: parseInt(el.getAttribute('data-i'), 10) || 0,
        kind: el.getAttribute('data-kind'),
        colors: words(el.getAttribute('data-colors')),
        cols: words(el.getAttribute('data-cols')).filter(function (h) { return colNames[h]; }),
        sizes: words(el.getAttribute('data-sizes')),
        price: parseFloat(el.getAttribute('data-price')) || 0,
        available: el.getAttribute('data-available') === 'true',
        created: parseInt(el.getAttribute('data-created'), 10) || 0,
        title: el.getAttribute('data-title') || '',
        search: norm(el.getAttribute('data-search'))
      };
    });
    if (!items.length) return;

    var priceMin = Math.floor(Math.min.apply(null, items.map(function (it) { return it.price; })) / 50) * 50;
    var priceMax = Math.ceil(Math.max.apply(null, items.map(function (it) { return it.price; })) / 50) * 50;

    /* Opciones que existen en esta colección */
    function present(key, order) {
      var seen = {};
      items.forEach(function (it) { [].concat(it[key]).forEach(function (v) { if (v) seen[v] = true; }); });
      var list = Object.keys(seen);
      if (order) list.sort(function (a, b) { return (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99); });
      else list.sort(function (a, b) { return (parseFloat(a) || 0) - (parseFloat(b) || 0) || a.localeCompare(b); });
      return list;
    }
    var GROUPS = [
      { key: 'tipo', field: 'kind', label: 'Tipo de pieza', options: present('kind', KIND_ORDER), name: function (v) { return KINDS[v] || v; } },
      { key: 'color', field: 'colors', label: 'Color de la piedra', options: present('colors', COLOR_ORDER), name: function (v) { return COLORS[v] || v.charAt(0).toUpperCase() + v.slice(1); }, swatch: true },
      { key: 'col', field: 'cols', label: 'Constelación', options: present('cols', Object.keys(colNames)), name: function (v) { return String(colNames[v] || v).replace('Orion', 'Orión'); } },
      { key: 'talla', field: 'sizes', label: 'Talla de anillo', options: present('sizes'), name: function (v) { return v; }, pills: true }
    ].filter(function (g) { return g.options.length > 1; });

    var state = { f: {}, min: priceMin, max: priceMax, disp: false, q: '', sort: defaultSort };
    GROUPS.forEach(function (g) { state.f[g.key] = []; });

    /* ---------- ¿Pasa la pieza? ---------- */
    function passGroup(it, g) {
      var sel = state.f[g.key];
      if (!sel.length) return true;
      var val = it[g.field];
      return Array.isArray(val) ? val.some(function (v) { return sel.indexOf(v) > -1; }) : sel.indexOf(val) > -1;
    }
    function passQuery(it) {
      if (!state.q) return true;
      return words(norm(state.q)).every(function (w) { return it.search.indexOf(w) > -1; });
    }
    function pass(it, skipKey) {
      if (state.disp && !it.available) return false;
      if (it.price < state.min || it.price > state.max) return false;
      if (!passQuery(it)) return false;
      for (var i = 0; i < GROUPS.length; i++) {
        if (GROUPS[i].key !== skipKey && !passGroup(it, GROUPS[i])) return false;
      }
      return true;
    }
    function countFor(g, v) {
      var n = 0;
      items.forEach(function (it) {
        if (!pass(it, g.key)) return;
        var val = it[g.field];
        if (Array.isArray(val) ? val.indexOf(v) > -1 : val === v) n++;
      });
      return n;
    }
    function activeCount() {
      var n = state.disp ? 1 : 0;
      GROUPS.forEach(function (g) { n += state.f[g.key].length; });
      if (state.min > priceMin || state.max < priceMax) n++;
      if (state.q) n++;
      return n;
    }

    /* ---------- Panel ---------- */
    function optionHtml(g, v, compact) {
      var sw = g.swatch ? '<span class="kf-sw kf-sw--' + esc(v) + '" aria-hidden="true"></span>' : '';
      return '<button type="button" class="kf__opt' + (g.pills ? ' kf__opt--pill' : '') + (g.swatch ? ' kf__opt--color' : '') + '"' +
        ' data-kf-opt="' + g.key + '" data-v="' + esc(v) + '" aria-pressed="false">' + sw +
        '<span class="kf__opt-name">' + esc(g.name(v)) + '</span>' +
        (compact ? '' : '<span class="kf__opt-n" data-kf-n></span>') + '</button>';
    }

    var html = '';
    GROUPS.forEach(function (g) {
      html += '<div class="kf__group" role="group" aria-labelledby="kf-' + g.key + '-' + root.id + '">' +
        '<p class="kf__group-title" id="kf-' + g.key + '-' + root.id + '">' + g.label + '</p>' +
        '<div class="kf__opts' + (g.swatch ? ' kf__opts--colors' : '') + (g.pills ? ' kf__opts--pills' : '') + '">' +
        g.options.map(function (v) { return optionHtml(g, v); }).join('') + '</div></div>';
    });
    if (priceMax - priceMin >= 100) {
      html += '<div class="kf__group" role="group" aria-labelledby="kf-precio-' + root.id + '">' +
        '<p class="kf__group-title" id="kf-precio-' + root.id + '">Precio</p>' +
        '<div class="kf__range">' +
        '<div class="kf__range-track"><span class="kf__range-fill" data-kf-fill></span>' +
        '<input type="range" data-kf-min min="' + priceMin + '" max="' + priceMax + '" step="50" value="' + priceMin + '" aria-label="Precio mínimo">' +
        '<input type="range" data-kf-max min="' + priceMin + '" max="' + priceMax + '" step="50" value="' + priceMax + '" aria-label="Precio máximo"></div>' +
        '<p class="kf__range-values"><span data-kf-min-label>' + money(priceMin) + '</span><span data-kf-max-label>' + money(priceMax) + '</span></p>' +
        '</div></div>';
    }
    if (items.some(function (it) { return !it.available; })) {
      html += '<div class="kf__group kf__group--row"><label class="kf__switch"><span>Solo disponibles</span>' +
        '<input type="checkbox" role="switch" data-kf-disp><span class="kf__switch-ui" aria-hidden="true"></span></label></div>';
    }
    groupsEl.innerHTML = html;

    /* Atajos rápidos (móvil): tipos + colores, a un toque */
    if (quickEl) {
      var q = '';
      GROUPS.forEach(function (g) {
        if (g.key !== 'tipo' && g.key !== 'color') return;
        g.options.forEach(function (v) { q += optionHtml(g, v, true); });
      });
      quickEl.innerHTML = q;
      quickEl.hidden = !q;
    }

    var minIn = root.querySelector('[data-kf-min]');
    var maxIn = root.querySelector('[data-kf-max]');
    var dispIn = root.querySelector('[data-kf-disp]');

    /* ---------- Pintar ---------- */
    var first = true;
    function paint(push) {
      var shown = 0;
      var order = items.slice();
      if (state.sort === 'precio-asc') order.sort(function (a, b) { return a.price - b.price || a.i - b.i; });
      else if (state.sort === 'precio-desc') order.sort(function (a, b) { return b.price - a.price || a.i - b.i; });
      else if (state.sort === 'nuevos') order.sort(function (a, b) { return b.created - a.created || a.i - b.i; });
      else if (state.sort === 'az') order.sort(function (a, b) { return a.title.localeCompare(b.title, 'es'); });
      else order.sort(function (a, b) { return a.i - b.i; });

      /* El conteo va antes de pintar: la transición corre apply() después y dejaba el total en 0 */
      order.forEach(function (it) { if (pass(it)) shown++; });

      function apply() {
        order.forEach(function (it, rank) {
          it.el.hidden = !pass(it);
          it.el.style.order = String(rank * 2);
        });
        var filtering = activeCount() > 0 || state.sort !== 'destacados';
        if (promo) {
          promo.hidden = filtering;
          promo.style.order = '15';
        }
        emptyEl.hidden = shown > 0;
        grid.hidden = shown === 0;
      }

      var canAnimate = !first && !reduce && document.startViewTransition;
      if (canAnimate) document.startViewTransition(apply);
      else apply();
      first = false;

      /* Conteos, estados y etiquetas */
      root.querySelectorAll('[data-kf-opt]').forEach(function (b) {
        var g = GROUPS.filter(function (x) { return x.key === b.getAttribute('data-kf-opt'); })[0];
        var v = b.getAttribute('data-v');
        var on = state.f[g.key].indexOf(v) > -1;
        var n = countFor(g, v);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !on && n === 0;
        var nEl = b.querySelector('[data-kf-n]');
        if (nEl) nEl.textContent = n;
      });

      var label = shown === 1 ? '1 pieza' : shown + ' piezas';
      resultEl.textContent = label;
      if (countEl) countEl.textContent = shown;
      var ac = activeCount();
      if (badgeEl) { badgeEl.hidden = !ac; badgeEl.textContent = ac; }
      renderActive();
      syncRange();
      if (push !== false) syncUrl();
    }

    function renderActive() {
      var chips = [];
      if (state.q) chips.push({ k: 'q', label: '“' + state.q + '”' });
      GROUPS.forEach(function (g) {
        state.f[g.key].forEach(function (v) { chips.push({ k: g.key, v: v, label: (g.key === 'talla' ? 'Talla ' : '') + g.name(v), sw: g.swatch ? v : '' }); });
      });
      if (state.min > priceMin || state.max < priceMax) chips.push({ k: 'precio', label: money(state.min) + ' a ' + money(state.max) });
      if (state.disp) chips.push({ k: 'disp', label: 'Solo disponibles' });
      activeEl.hidden = !chips.length;
      activeEl.innerHTML = chips.map(function (c) {
        return '<button type="button" class="kf__chip" data-kf-remove="' + c.k + '"' + (c.v ? ' data-v="' + esc(c.v) + '"' : '') + ' aria-label="Quitar ' + esc(c.label) + '">' +
          (c.sw ? '<span class="kf-sw kf-sw--' + esc(c.sw) + '" aria-hidden="true"></span>' : '') +
          esc(c.label) + '<i class="ph ph-x" aria-hidden="true"></i></button>';
      }).join('') + (chips.length > 1 ? '<button type="button" class="kf__link" data-kf-clear>Limpiar todo</button>' : '');
    }

    function syncRange() {
      if (!minIn) return;
      minIn.value = state.min; maxIn.value = state.max;
      var span = priceMax - priceMin || 1;
      var fill = root.querySelector('[data-kf-fill]');
      fill.style.left = ((state.min - priceMin) / span * 100) + '%';
      fill.style.right = (100 - (state.max - priceMin) / span * 100) + '%';
      root.querySelector('[data-kf-min-label]').textContent = money(state.min);
      root.querySelector('[data-kf-max-label]').textContent = money(state.max);
      if (dispIn) dispIn.checked = state.disp;
      if (sortEl) sortEl.value = state.sort;
      if (qEl && document.activeElement !== qEl) qEl.value = state.q;
    }

    /* ---------- Dirección ---------- */
    function syncUrl() {
      if (!history.replaceState) return;
      var url = new URL(window.location.href);
      GROUPS.forEach(function (g) {
        if (state.f[g.key].length) url.searchParams.set(g.key, state.f[g.key].join(','));
        else url.searchParams.delete(g.key);
      });
      if (state.min > priceMin) url.searchParams.set('min', state.min); else url.searchParams.delete('min');
      if (state.max < priceMax) url.searchParams.set('max', state.max); else url.searchParams.delete('max');
      if (state.disp) url.searchParams.set('disp', '1'); else url.searchParams.delete('disp');
      if (state.sort !== defaultSort) url.searchParams.set('orden', state.sort); else url.searchParams.delete('orden');
      if (state.q) url.searchParams.set('q', state.q); else url.searchParams.delete('q');
      history.replaceState(history.state, '', url.toString());
    }
    function readUrl() {
      var p = new URLSearchParams(window.location.search);
      GROUPS.forEach(function (g) {
        var raw = p.get(g.key);
        if (!raw) return;
        var plural = { anillos: 'anillo', collares: 'collar', pulseras: 'pulsera' };
        state.f[g.key] = raw.split(',').map(function (v) { v = norm(v).trim(); return plural[v] || v; })
          .filter(function (v) { return g.options.indexOf(v) > -1; });
      });
      var mn = parseFloat(p.get('min')), mx = parseFloat(p.get('max'));
      if (!isNaN(mn)) state.min = Math.max(priceMin, Math.min(mn, priceMax));
      if (!isNaN(mx)) state.max = Math.min(priceMax, Math.max(mx, state.min));
      state.disp = p.get('disp') === '1';
      var o = p.get('orden');
      if (o && sortEl && sortEl.querySelector('option[value="' + o + '"]')) state.sort = o;
      state.q = (p.get('q') || '').slice(0, 60);
    }

    /* ---------- Eventos ---------- */
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-kf-opt]');
      if (opt && !opt.disabled) {
        var list = state.f[opt.getAttribute('data-kf-opt')];
        var v = opt.getAttribute('data-v');
        var at = list.indexOf(v);
        if (at > -1) list.splice(at, 1); else list.push(v);
        paint();
        /* Desde la barra fija: sube al inicio de los resultados para ver el cambio */
        var stickyBar = root.querySelector('[data-kf-sticky].is-stuck');
        var sent = root.querySelector('[data-kf-sentinel]');
        if (stickyBar && sent && opt.closest('[data-kf-quick]')) {
          var y0 = sent.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(root).getPropertyValue('--kf-top')) || 0);
          window.scrollTo({ top: y0, behavior: reduce ? 'auto' : 'smooth' });
        }
        return;
      }
      var rm = e.target.closest('[data-kf-remove]');
      if (rm) {
        var k = rm.getAttribute('data-kf-remove');
        if (k === 'q') state.q = '';
        else if (k === 'precio') { state.min = priceMin; state.max = priceMax; }
        else if (k === 'disp') state.disp = false;
        else {
          var arr = state.f[k], idx = arr.indexOf(rm.getAttribute('data-v'));
          if (idx > -1) arr.splice(idx, 1);
        }
        paint();
        return;
      }
      if (e.target.closest('[data-kf-clear]')) {
        GROUPS.forEach(function (g) { state.f[g.key] = []; });
        state.min = priceMin; state.max = priceMax; state.disp = false; state.q = '';
        paint();
        return;
      }
      if (e.target.closest('[data-kf-open]')) { openPanel(); return; }
      if (e.target.closest('[data-kf-close]')) { closePanel(); }
    });

    if (minIn) {
      minIn.addEventListener('input', function () { state.min = Math.min(parseFloat(minIn.value), state.max - 50); paint(); });
      maxIn.addEventListener('input', function () { state.max = Math.max(parseFloat(maxIn.value), state.min + 50); paint(); });
    }
    if (dispIn) dispIn.addEventListener('change', function () { state.disp = dispIn.checked; paint(); });
    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; paint(); });
    if (qEl) {
      var qt;
      qEl.addEventListener('input', function () {
        clearTimeout(qt);
        qt = setTimeout(function () { state.q = qEl.value.trim().slice(0, 60); paint(); }, 160);
      });
    }

    /* Hoja de filtros en móvil */
    var lastFocus = null;
    function openPanel() {
      if (!mobileMq.matches) {
        var firstCtl = panel.querySelector('input, button:not([disabled])');
        if (firstCtl) firstCtl.focus();
        return;
      }
      lastFocus = document.activeElement;
      root.classList.add('is-kf-open');
      scrim.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var c = panel.querySelector('.kf__close'); if (c) c.focus(); }, 60);
    }
    function closePanel() {
      if (!root.classList.contains('is-kf-open')) return;
      root.classList.remove('is-kf-open');
      scrim.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
      var top = root.querySelector('.kf__bar');
      if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
    mobileMq.addEventListener && mobileMq.addEventListener('change', function () { if (!mobileMq.matches) closePanel(); });

    /* Barra fija en móvil: se pega justo debajo del header (mide su alto real) */
    var sticky = root.querySelector('[data-kf-sticky]');
    var sentinel = root.querySelector('[data-kf-sentinel]');
    if (sticky && sentinel && 'IntersectionObserver' in window) {
      var header = document.querySelector('.cenit-header-wrapper');
      var measure = function () {
        var top = 0;
        if (header) {
          var pos = getComputedStyle(header).position;
          var r = header.getBoundingClientRect();
          if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0) top = Math.round(r.bottom);
        }
        root.style.setProperty('--kf-top', top + 'px');
      };
      measure();
      if (header && 'ResizeObserver' in window) new ResizeObserver(measure).observe(header);
      new IntersectionObserver(function (entries) {
        var stuck = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        measure();
        sticky.classList.toggle('is-stuck', stuck);
      }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' }).observe(sentinel);
    }

    readUrl();
    paint(false);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-kf]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
